import { http } from '@/utils/wallet/http.js';

/**
 * 获取会员信息
 */
export function queryMemberInfo() {
  return http.request({
    url: '/order/front/center/queryMemberInfo',
    method: 'get',
    toast: true,
  });
}

/**
 * 获取钱包余额
 */
export function queryBalance() {
  return http.request({
    url: '/order/front/center/queryBalance',
    method: 'get',
  });
}

/**
 * 获取申诉列表
 */
export function queryAppealList(data) {
  return http.request({
    url: '/order/chat/tradeDispute/getList',
    method: 'post',
    data,
  });
}

/**
 * 获取支付方式列表
 */
export function queryPayTypeInfo() {
  return http.request({
    url: '/order/front/center/queryPayTypeInfo',
    method: 'get',
  });
}

// 查询银行卡账户姓名（与收银台 queryBankAccountName 返回格式一致：code=0 时 data 为姓名字符串）
export function queryBankAccountName() {
  return http.request({
    url: '/order/front/center/queryBankAccountName',
    method: 'get',
    allowEmptySuccess: true,
  });
}

// 获取银行列表
export function getBankWallet(params) {
  return http.request({
    url: '/counter/front/merchant/bank',
    method: 'get',
    params,
  });
}

/**
 * 上传身份证正面
 */
export function uploadSFZFront(data) {
  return http.request({
    url: '/order/front/center/uploadSFZFront',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    toast: true,
  });
}

/**
 * 上传身份证反面
 */
export function uploadSFZBack(data) {
  return http.request({
    url: '/order/front/center/uploadSFZBack',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    toast: true,
  });
}

/**
 * OCR识别身份证信息
 */
export function uploadSFZOcrId(data) {
  return http.request({
    url: '/order/front/center/ocrId',
    method: 'post',
    data,
    toast: true,
    returnErrMsg: true,
  });
}

/**
 * 保存身份证信息
 */
export function saveOcrInfo() {
  return http.request({
    url: '/order/front/center/saveOcrInfo',
    method: 'get',
    toast: true,
  });
}

/**
 * 购买订单列表（钱包业务）
 */
export function getBuyLists(data) {
  return http.request({
    url: '/order/front/buyOrder/v2/sellPage',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取提现信息
 */
export function getWithdrawInfo(data) {
  return http.request({
    url: '/order/front/sell/withdrawInfo',
    method: 'get',
    data,
  });
}

/**
 * 获取商户取款方式
 */
export function getWithdrawalMethod(data) {
  return http.request({
    url: '/order/front/sellOrder/v2/withdrawalMethod',
    method: 'get',
    data,
  });
}

/**
 * 拆分固定金额
 */
export function splitFixedAmount(data) {
  return http.request({
    url: '/order/front/sellOrder/v2/splitFixedAmount',
    method: 'get',
    params: data,
  });
}

/**
 * 创建出售订单
 */
export function sellOrderCreate(data) {
  return http.request({
    url: '/order/front/sell/create',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 商户取款下单
 */
export function sellPlaceTransferOrder(data) {
  return http.request({
    url: '/order/front/sellOrder/v2/placeTransferOrder',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 购买支付方式列表（电子钱包数据结构与收银台 paymentMethod 一致）
 */
export function getBuyPaymentMethod(params) {
  return http.request({
    url: '/order/front/buyOrder/v2/paymentMethod',
    method: 'get',
    params,
  });
}

/**
 * 购买下单前手机号绑定校验
 */
export function postBuyOrderPhoneBindCheck(params) {
  return http.request({
    url: '/order/front/buyOrder/v2/phoneBind/check',
    method: 'get',
    params,
  });
}

/**
 * 获取购买订单配置
 */
export function buyOrderConfig(data) {
  return http.request({
    url: '/order/front/buyOrder/v2/buyOrderConfig',
    method: 'post',
    data,
  });
}

/**
 * 查询进行中的撮合充值订单（未完成需继续处理）
 */
export function getInProgressMatchOrder(params) {
  return http.request({
    url: '/order/front/buyOrder/v2/getInProgressMatchOrder',
    method: 'get',
    params,
  });
}

/**
 * 上传固额二维码
 */
export function uploadFixedAmountQRCode(data) {
  return http.request({
    url: '/order/front/sellOrder/v2/uploadFixedAmountQRCode',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 查询钱包余额（68C）
 */
export function queryBalance68c() {
  return http.request({
    url: '/order/front/merchant/v68/queryBalance',
    method: 'get',
  });
}

/**
 * 查询可卖出余额
 */
export function queryAvailableBalance() {
  return http.request({
    url: '/order/front/sellOrder/v2/availableBalance',
    method: 'get',
  });
}

/**
 * 创建购买订单
 */
export function getBuyCreate(data) {
  return http.request({
    url: '/order/front/buyOrder/v2/buyFromSellList',
    method: 'post',
    data,
    needAllData: true,
  });
}

// 取消购买
export function userCancelBuyOrder(data) {
  return http.request({
    url: '/order/front/trade/userCancelBuyOrder',
    method: 'post',
    data,
  });
}

/**
 * 查询用户是否存在
 */
export function checkUserIsExists(data) {
  return http.request({
    url: `/order/front/auth/checkUserIsExists`,
    method: 'post',
    data,
    ignoreToken: true,
    needAllData: true,
  });
}

/**
 * 用户登录
 */
export function login(data) {
  return http.request({
    url: '/order/front/auth/login',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
    needAllData: true,
  });
}

/**
 * 用户退出登录
 */
export function logout() {
  return http.request({
    url: '/order/front/center/logout',
    method: 'post',
    needAllData: true,
  });
}

/**
 * 用户注册
 */
export function register(data) {
  return http.request({
    url: '/order/front/auth/register',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
  });
}

/**
 * 重置密码
 */
export function resetPwd(data) {
  return http.request({
    url: '/order/front/auth/resetPwd',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
  });
}

/**
 * 修改密码
 */
export function resetCenterPwd(data) {
  return http.request({
    url: '/order/front/center/resetPwd',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 修改安全密码
 */
export function resetCenterSafePwd(data) {
  return http.request({
    url: '/order/front/center/updateSafePwd',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取手机号区号列表
 */
export function countryPhoneInfoList() {
  return http.request({
    url: '/order/front/auth/countryPhoneInfoList',
    method: 'get',
    ignoreToken: true,
  });
}

/**
 * 发送短信验证码
 */
export function sendPhoneSmsForForgetPwd(data) {
  return http.request({
    url: '/order/front/auth/sendPhoneSmsForForgetPwd',
    method: 'post',
    data,
    toast: true,
  });
}
export function sendPhoneSmsForLogin(data) {
  return http.request({
    url: '/order/front/auth/sendPhoneSmsForLogin',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 发送安全密码短信验证码
 */
export function sendPhoneSmsBySafe(data) {
  return http.request({
    url: '/order/front/center/sendPhoneSmsBySafe',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 发送短信验证码（绑定手机号）
 */
export function sendPhoneSmsBySyncPhone(data) {
  return http.request({
    url: '/order/front/center/sendPhoneSmsBySyncPhone',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 验证短信验证码
 */
export function verifySmsCodeForForgetPwd(data) {
  return http.request({
    url: '/order/front/auth/verifySmsCodeForForgetPwd',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
  });
}

export function verifySmsCodeForLogin(data) {
  return http.request({
    url: '/order/front/auth/verifySmsCodeForLogin',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
  });
}

/**
 * 绑定手机号
 */
export function syncPhone(data) {
  return http.request({
    url: '/order/front/center/syncPhone',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 短信登录
 */
export function smsLogin(data) {
  return http.request({
    url: '/order/front/auth/smsLogin',
    method: 'post',
    data,
    ignoreToken: true,
    toast: true,
  });
}

/**
 * 查询钱包余额
 */
export function queryWalletBalance() {
  return http.request({
    url: '/order/front/center/queryWalletBalance',
    method: 'get',
    toast: true,
  });
}
/** ======================================================== 支付账户 */

/**
 * 保存支付账户类型
 */
export function savePayTypeInfo(data) {
  return http.request({
    url: '/order/front/center/savePayTypeInfo',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 发送支付账户类型短信验证码
 */
export function sendPayTypeInfoSms(data) {
  return http.request({
    url: '/order/front/center/sendPayTypeInfoSms',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 上传支付账户二维码
 */
export function uploadPayTypeInfoQRCode(data) {
  return http.request({
    url: '/order/front/center/uploadQRCode',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 删除支付账户
 */
export function deletePayTypeInfoById(id) {
  return http.request({
    url: `/order/front/center/deletePayTypeInfoById?id=${id}`,
    method: 'get',
  });
}

/**
 * 获取银行列表
 */
// export function getBankWallet(params) {
//   return http.request({
//     url: '/order/front/center/getBankList',
//     method: 'get',
//     params,
//   });
// }

/**
 * 获取订单列表
 */
export function getTradePage(data) {
  return http.request({
    url: '/order/front/trade/v2/page',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取买入订单列表
 */
export function getBuyOrderProcessPage(data) {
  return http.request({
    url: '/order/front/buyOrder/v2/queryProcessPage',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取资金明细列表
 */
export function getFundDetailList(data) {
  return http.request({
    url: '/order/front/tradeFund/v2/detailList',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取资金明细详情
 */
export function getFundDetail(data) {
  return http.request({
    url: '/order/front/tradeFund/v2/detail',
    method: 'post',
    data,
    toast: true,
  });
}

/** ======================================================== 68 */

/**
 * 查询手机号
 */
export function queryPhoneNoV68() {
  return http.request({
    url: '/order/front/merchant/v68/queryPhoneNo',
    method: 'get',
  });
}

/**
 * 查询是否实名
 */
export function queryIfRealNameV68(params) {
  return http.request({
    url: '/order/front/merchant/v68/queryIfRealName',
    method: 'get',
    params,
  });
}

/**
 * 查询钱包余额
 */
export function queryBalanceV68() {
  return http.request({
    url: '/order/front/merchant/v68/queryBalance',
    method: 'get',
  });
}

/**
 * 手动接单
 */
export function receivingOrder(params) {
  return http.request({
    url: '/order/front/trade/receivingOrder',
    method: 'get',
    params,
    toast: true,
  });
}

/**
 * 卖家拒绝订单
 */
export function adCancelOrder(params) {
  return http.request({
    url: '/order/front/trade/adCancelOrder',
    method: 'get',
    params,
  });
}

/**
 * 获取配置信息
 */
export function exchangeRateConfigGetsetting(params) {
  return http.request({
    url: '/order/front/exchangeRateConfig/getSetting',
    method: 'get',
    params,
  });
}

/**
 * 获取启用配置列表
 */
export function transferSettingsGetEnableList(params) {
  return http.request({
    url: '/order/front/transferSettings/getEnableList',
    method: 'get',
    params,
  });
}

/**
 * 获取配置信息
 */
export function exchangeSettingsGetSetting(params) {
  return http.request({
    url: '/order/front/exchangeSettings/getSetting',
    method: 'get',
    params,
  });
}

/**
 * 转账-验证支付密码
 */
export function transferVerifyPwd(data) {
  return http.request({
    url: '/order/front/transfer/verifyPwd',
    method: 'post',
    data,
    toast: true,
    needAllData: true,
  });
}

/**
 * 转账-转账
 */
export function transferApi(data) {
  return http.request({
    url: '/order/front/transfer/transfer',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取转账信息
 */
export function queryTransferInfo(params) {
  return http.request({
    url: '/order/front/transfer/queryTransferInfo',
    method: 'get',
    params,
  });
}

/**
 * 根据币种计算转账手续费
 */
export function queryTransferFee(params) {
  return http.request({
    url: '/order/front/transfer/queryTransferFee',
    method: 'get',
    params,
    toast: true,
  });
}

/**
 * 兑换
 */
export function exchangeApi(data) {
  return http.request({
    url: '/order/front/exchange/exchange',
    method: 'post',
    data,
    toast: true,
    needAllData: true,
  });
}

/**
 * 新页面调用一次才会有推送
 */
export function confirmAndRecommand() {
  return http.request({
    url: '/order/front/tradeNotify/confirmAndRecommand',
    method: 'get',
  });
}

/**
 * 获取转账地址簿列表
 */
export function transferAddressBookList(params) {
  return http.request({
    url: '/order/front/transferAddressBook/list',
    method: 'get',
    params,
  });
}

/**
 * 保存转账地址簿
 */
export function transferAddressBookSave(data) {
  return http.request({
    url: '/order/front/transferAddressBook/save',
    method: 'post',
    data,
    toast: true,
    needAllData: true,
  });
}

/**
 * 删除地址薄
 */
export function transferAddressBookDelete(id) {
  return http.request({
    url: `/order/front/transferAddressBook/delete/${id}`,
    method: 'post',
    data: {},
    toast: true,
  });
}

/**
 * 用户注登录-授权-确认
 */
export function authWalletBind(data) {
  return http.request({
    url: '/order/front/authBind/walletBind',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 68内部账号登录获取登录信息
 */
export function authCheckGetLoginInfo(data) {
  return http.request({
    url: '/order/front/auth/getLoginInfo',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 获取购买交易类型
 */
export function getBuyTradeType() {
  return http.request({
    url: '/order/front/buyOrder/v2/buyTradeType',
    method: 'get',
    toast: true,
  });
}

/**
 * 获取单聊客服链接
 */
export function authChatCreateSingleLink(data) {
  return http.request({
    url: '/order/front/auth/createSingleLink',
    method: 'post',
    data,
    toast: true,
  });
}

/**
 * 交易订单数量
 */
export function tradeTotal(data) {
  return http.request({
    url: '/order/front/trade/v2/total',
    method: 'post',
    data,
  });
}

/**
 * 获取一键退回开关（0 不显示退回账户按钮，1 显示）
 */
export function getOneClickRefundSwitch() {
  return http.request({
    url: '/order/front/sell/custom/oneClickRefundSwitch',
    method: 'get',
  });
}

/**
 * 获取会员审核中金额
 */
export function getMemberUnderReviewAmounts(params = {}) {
  return http.request({
    url: '/order/front/sell/custom/memberUnderReviewAmounts',
    method: 'get',
    params,
  });
}

/**
 * 获取用户可退款列表（弹窗列表）
 */
export function getRefundList(params = {}) {
  return http.request({
    url: '/order/front/sell/custom/refundList',
    method: 'get',
    params,
    toast: true,
  });
}

/**
 * 退回（点击回退按钮时调用）
 */
export function sellRefund(data = {}) {
  return http.request({
    url: '/order/front/sell/custom/sellRefund',
    method: 'post',
    data,
    toast: false,
    needAllData: true,
  });
}

/**
 * 退回配置（获取限制小时数等）
 */
export function getSellRefundConfig() {
  return http.request({
    url: '/order/front/sell/custom/sellRefundConfig',
    method: 'post',
    data: {},
    toast: false,
  });
}

/**
 * 钱包安全存款
 */
export function walletSafeDeposit(data) {
  return http.request({
    url: '/order/front/wallet/safeDeposit',
    method: 'post',
    data,
    needAllData: true,
  });
}

export function getConfirmSellOrderOption(data) {
  return http.request({
    url: '/order/chat/auth/getConfirmSellOrderOption',
    method: 'post',
    data,
    toast: true,
  });
}

export function verifyConfirmSellOrderOption(data) {
  return http.request({
    url: '/order/chat/auth/verifyConfirmSellOrderOption',
    method: 'post',
    data,
    toast: true,
  });
}

export function checkPayPass(data) {
  return http.request({
    url: '/order/chat/auth/checkPayPass',
    method: 'post',
    data,
    toast: true,
  });
}
